import moment from 'moment';

import { Nullable } from '../../../utils/types';

export const formatDate = (value: Nullable<Date>) => (value ? moment(value).format('DD.MM.YYYY HH:mm') : '—');
